import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useUser } from 'context/user/User';
import cashierSessionsApi from 'api/requests/cashierSessions';

const CashierContext = createContext();

export default function CashierProvider({ children }) {
    const { user } = useUser();
    const slug = user?.establishments?.[0]?.slug;

    const [openSession, setOpenSession] = useState(null);
    const [loadingSession, setLoadingSession] = useState(true);

    const refreshSession = useCallback(async () => {
        if (!slug) return;
        setLoadingSession(true);
        try {
            const res = await cashierSessionsApi.list(slug, { status: 'open' });
            const sessions = res.data?.data || [];
            setOpenSession(sessions[0] || null);
        } catch {
            setOpenSession(null);
        } finally {
            setLoadingSession(false);
        }
    }, [slug]);

    useEffect(() => {
        refreshSession();
    }, [refreshSession]);

    const posEvent = openSession?.pos_event ?? null;

    return (
        <CashierContext.Provider value={{ openSession, posEvent, loadingSession, refreshSession }}>
            {children}
        </CashierContext.Provider>
    );
}

export function useCashier() {
    const ctx = useContext(CashierContext);
    if (!ctx) throw new Error('useCashier must be used within CashierProvider');
    return ctx;
}
